import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Header() {
  return (
    <header
      className="sticky top-0 z-40 border-b border-[#e5e2da]"
      style={{ background: "rgba(249,248,246,0.92)", backdropFilter: "blur(8px)" }}
      data-testid="marketing-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-home-link">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-[#f9f8f6] font-serif-display text-xl"
            style={{ background: "#163325" }}
          >
            C
          </div>
          <span className="font-serif-display text-2xl leading-none">Coachly</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-[#3c3c3c]">
          <a href="#how" className="hover:text-[#163325] transition-colors" data-testid="nav-how">How it works</a>
          <a href="#proof" className="hover:text-[#163325] transition-colors" data-testid="nav-proof">Proof</a>
          <a href="#pricing" className="hover:text-[#163325] transition-colors" data-testid="nav-pricing">Pricing</a>
          <a href="#faq" className="hover:text-[#163325] transition-colors" data-testid="nav-faq">FAQ</a>
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/login" data-testid="header-signin-link">
            <Button variant="ghost" className="rounded-full text-[#163325] hover:bg-[#ebe8e0]">
              Sign in
            </Button>
          </Link>
          <Link to="/plans" data-testid="header-signup-link">
            <Button
              className="rounded-full bg-[#163325] hover:bg-[#0e2419] text-[#f9f8f6] px-5"
              style={{ transition: "transform 160ms, background-color 160ms" }}
            >
              Start trial
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
